import type { GameDirectSource } from '@sunflower-games/analytics-events';

// How the browser opened this page, for a launch on page load that the lobby did not start.
// Undefined when the page wasn't opened on a game.
export function getPageOpenTrigger(): GameDirectSource | undefined {
  const [navigation] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
  if (navigation && !new URL(navigation.name, window.location.origin).pathname.startsWith('/games/')) {
    return undefined;
  }
  switch (navigation?.type) {
    case 'reload':
      return 'refresh';
    case 'back_forward':
      return 'restored_tab';
    default:
      return 'direct_url';
  }
}
